import { ElNotification } from 'element-plus'

export function notifySuccess(tittle: string, message: string, duration: number = 4500) {
    ElNotification({
        title: tittle,
        message: message,
        type: 'success',
        duration: duration
    })
}

export function succesPermanent(tittle: string, message: string) {
    notifySuccess(tittle, message, 0);
}

export function notifyWarning(tittle: string, message: string, duration: number = 4500) {
    ElNotification({
        title: tittle,
        message: message,
        type: 'warning',
        duration: duration
    })
}

export function warningPermanent(tittle: string, message: string) {
    notifyWarning(tittle, message, 0);
}

export function notifyWarningPermanentHtml(tittle: string, messageHtml: string) {
    ElNotification({
        title: tittle,
        dangerouslyUseHTMLString: true,
        message: messageHtml,
        type: 'warning',
        duration: 0,
    })
}

export function notifyInfo(tittle: string, message: string, duration: number = 4500) {
    ElNotification({
        title: tittle,
        message: message,
        type: 'info',
        duration: duration
    })
}

export function infoPermanent(tittle: string, message: string) {
    notifyInfo(tittle, message, 0);
}

export function error(tittle: string, message: string, duration: number = 4500) {
    ElNotification({
        title: tittle,
        message: message,
        type: 'error',
        duration: duration
    })
}

export function notifyErrorPermanent(tittle: string, message: string) {
    error(tittle, message, 0);
}
